import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FaLock, FaEye, FaEyeSlash, FaBriefcaseMedical, FaCheckCircle } from 'react-icons/fa';
import api from '../services/api';
import { useApp } from '../context/AppContext';

const PRIMARY = '#E8500A';
const SECONDARY = '#FF6B2C';
const DARK = '#1a1a2e';
const MUTED = '#8888a8';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const location = useLocation();
  const navigate = useNavigate();
  const { showToast } = useApp();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      return showToast('Passwords do not match', 'error');
    }

    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      return showToast('Reset token is missing', 'error');
    }

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setSuccess(true);
      setTimeout(() => navigate('/patient/login'), 3000);
    } catch (err) {
      showToast(err.response?.data?.message || 'Something went wrong', 'error');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5',
      padding: '20px',
      fontFamily: "'Segoe UI', sans-serif"
    }}>
      <div style={{
        maxWidth: '450px',
        width: '100%',
        background: 'white',
        borderRadius: '24px',
        padding: '48px 40px',
        boxShadow: '0 24px 80px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 30 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: `linear-gradient(135deg,${PRIMARY},${SECONDARY})`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(232,80,10,0.32)',
          }}>
            <FaBriefcaseMedical size={18} color="white" />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 800, color: DARK, lineHeight: 1.2 }}>DocApps</div>
            <div style={{ fontSize: 10, color: MUTED, lineHeight: 1.2 }}>Solutions</div>
          </div>
        </div>

        {!success ? (
          <>
            <h1 style={{ fontSize: 24, fontWeight: 800, color: DARK, margin: '0 0 10px' }}>Reset Password</h1>
            <p style={{ fontSize: 14, color: MUTED, marginBottom: 30 }}>Enter your new password below.</p>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
              <div style={{ position: 'relative' }}>
                <span style={{
                  position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
                  color: '#b8b8d0', fontSize: 14
                }}><FaLock /></span>
                <input
                  required type={showPwd ? 'text' : 'password'}
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  placeholder="New Password"
                  style={{
                    width: '100%', padding: '12px 42px', border: '1.5px solid #e8e8f0',
                    borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box'
                  }}
                />
                <span
                  onClick={() => setShowPwd(!showPwd)}
                  style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', color: '#b8b8d0', cursor: 'pointer' }}
                >
                  {showPwd ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div style={{ position: 'relative' }}>
                <span style={{
                  position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
                  color: '#b8b8d0', fontSize: 14
                }}><FaLock /></span>
                <input
                  required type="password"
                  value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm New Password"
                  style={{
                    width: '100%', padding: '12px 14px 12px 42px', border: '1.5px solid #e8e8f0',
                    borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box'
                  }}
                />
              </div>

              <button
                type="submit" disabled={loading}
                style={{
                  padding: '14px 0', background: loading ? '#ccc' : `linear-gradient(135deg,${PRIMARY},${SECONDARY})`,
                  color: 'white', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700,
                  cursor: loading ? 'not-allowed' : 'pointer', boxShadow: '0 4px 18px rgba(232,80,10,0.35)'
                }}
              >
                {loading ? 'Updating...' : 'Reset Password'}
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <FaCheckCircle size={50} color="#28a745" style={{ marginBottom: 20 }} />
            <h2 style={{ fontSize: 22, fontWeight: 800, color: DARK, margin: '0 0 10px' }}>Password Reset!</h2>
            <p style={{ fontSize: 14, color: MUTED, marginBottom: 30 }}>Your password has been updated. Redirecting to login...</p>
            <Link to="/login" style={{ color: PRIMARY, fontWeight: 700, textDecoration: 'none' }}>Go to Login now</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
